import { useState } from 'react';
import { Search } from 'lucide-react';
import { Input } from '@/components/ui/input';
import { cn } from '@/lib/utils';
import type { RoleDto } from '../types';

interface RoleListProps {
  roles: RoleDto[];
  selectedRole: RoleDto | null;
  onSelectRole: (role: RoleDto) => void;
}

export function RoleList({ roles, selectedRole, onSelectRole }: RoleListProps) {
  const [searchTerm, setSearchTerm] = useState('');

  const filteredRoles = roles.filter(
    (role) =>
      role.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      role.roleCode.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="flex flex-col h-full">
      {/* Search */}
      <div className="p-4 border-b">
        <div className="relative">
          <Search className="absolute left-2.5 top-2.5 h-4 w-4 text-muted-foreground" />
          <Input
            placeholder="Search roles..."
            className="pl-8"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
      </div>

      {/* Role List */}
      <div className="flex-1 overflow-y-auto">
        {filteredRoles.length === 0 ? (
          <div className="p-4 text-center text-muted-foreground text-sm">
            No roles found
          </div>
        ) : (
          <div className="divide-y">
            {filteredRoles.map((role) => (
              <button
                key={role.id}
                onClick={() => onSelectRole(role)}
                className={cn(
                  'w-full text-left px-4 py-3 hover:bg-muted/50 transition-colors',
                  selectedRole?.id === role.id && 'bg-muted'
                )}
              >
                <div className="font-medium text-sm">{role.name}</div>
                <div className="text-xs text-muted-foreground mt-0.5">
                  <code>{role.roleCode}</code>
                  <span className="mx-1">·</span>
                  {role.permissions.length} permission{role.permissions.length !== 1 ? 's' : ''}
                </div>
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
